import { hc } from 'hono/client';
// Spec #149 Phase 2 (T2.3): consume the Hono RPC type from the Phase 1
// server (`apps/api`). We import via `@quon/api/rpc` which is `import type`-only
// so the desktop bundle never pulls jose / Supabase server code.
import type { ApiType } from '@quon/api/rpc';
import { env } from './env';
import { getAccessToken } from './auth';

export type ApiClient = ReturnType<typeof hc<ApiType>>;

/**
 * Hono RPC client factory.
 *
 * - The `headers` callback is invoked **per request** by `hono/client`, so the
 *   bearer token always reflects the current Supabase session even after a
 *   silent refresh.
 * - We expose `getApi()` (singleton) for components that just need to issue
 *   reads, plus `createApiClient()` for tests / per-call overrides.
 */
export function createApiClient(opts?: {
  baseUrl?: string;
  tokenProvider?: () => Promise<string | null>;
}): ApiClient {
  const baseUrl = opts?.baseUrl ?? env.apiBaseUrl;
  const tokenProvider = opts?.tokenProvider ?? getAccessToken;

  return hc<ApiType>(baseUrl, {
    headers: async (): Promise<Record<string, string>> => {
      const token = await tokenProvider();
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
  });
}

let cached: ApiClient | null = null;
export function getApi(): ApiClient {
  if (!cached) cached = createApiClient();
  return cached;
}
